import React from 'react';

import { SelectItemType } from '../Select/Select';
import styles from './SelectHeaderValue.module.css';

export type Props = {
  item?: SelectItemType;
  placeholder: string;
};

export const SelectHeaderValue = React.memo((props: Props) => {
  const {
    item,
    placeholder,
  } = props;

  return (
    <>
      {item
        ? item.icon ? (

          <div className={styles.selectHeaderValueWithIcon}>
            {item.icon}
            {item.label}
          </div>

        ) : item.label : placeholder}
    </>
  );
});

SelectHeaderValue.displayName = 'SelectHeaderValue';
